<section class="request-entry">
  <header class="request-entry__header">
    <div>
      <span class="request-entry__eyebrow">Solicitar novo servico</span>
    </div>

    <div class="request-entry__steps" aria-label="Etapas da solicitacao">
      <span class="request-entry__step request-entry__step--active">
        1. Descricao
      </span>
      <span class="request-entry__step">2. Detalhes</span>
    </div>
  </header>

  <mat-dialog-content class="request-entry__content">
    <div class="request-entry__body">
      <div class="request-entry__copy">
        <h3>Conte o que precisa ser resolvido</h3>
        <p>{{ helperInstruction }}</p>
      </div>

      @if (showTextField) {
        <div class="request-entry__text-panel">
          <mat-form-field appearance="outline" class="request-entry__textarea">
            <textarea
              matInput
              placeholder="Descreva o problema..."
              rows="6"
              [(ngModel)]="occurrence"
              [disabled]="isLoading"
            ></textarea>
          </mat-form-field>

          <button
            type="button"
            class="request-entry__voice-button"
            (click)="toggleTextField()"
            [disabled]="isLoading"
            matTooltip="Usar audio"
            matTooltipPosition="above"
          >
            <i-tabler name="microphone" class="request-entry__voice-icon"></i-tabler>
          </button>
        </div>

        <div class="request-entry__meta">
          <span
            class="request-entry__counter"
            [class.request-entry__counter--ready]="canUseAi"
          >
            {{ occurrenceLength }}/{{ minimumDescriptionLength }} caracteres
          </span>
          <span>
            {{ canUseAi ? 'Pronto para apoio da IA.' : 'Minimo para IA ainda nao atingido.' }}
          </span>
        </div>
      } @else {
        <div class="request-entry__record-panel">
          @if (!audioUrl) {
            <button
              type="button"
              class="request-entry__record-button"
              [class.request-entry__record-button--recording]="isRecording"
              (click)="isRecording ? stopRecording() : startRecording()"
              [disabled]="isLoading"
            >
              <i-tabler
                [name]="isRecording ? 'square-filled' : 'microphone'"
                class="request-entry__record-icon"
              ></i-tabler>
            </button>
          } @else {
            <div class="request-entry__audio-review">
              <audio [src]="audioUrl" controls class="request-entry__audio"></audio>
              <button
                type="button"
                mat-icon-button
                color="warn"
                (click)="deleteRecording()"
                matTooltip="Excluir audio"
                matTooltipPosition="above"
                [disabled]="isLoading"
              >
                <i-tabler name="trash" class="request-entry__trash-icon"></i-tabler>
              </button>
            </div>
          }

          <button
            type="button"
            class="request-entry__text-mode"
            (click)="switchToTextMode()"
            [disabled]="isLoading"
          >
            Voltar para texto
          </button>
        </div>
      }

      @if (errorMessage) {
        <div class="request-entry__error" role="alert">
          <i-tabler name="alert-triangle" class="request-entry__error-icon"></i-tabler>
          <span>{{ errorMessage }}</span>
        </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="request-entry__actions">
    <button
      type="button"
      mat-stroked-button
      color="warn"
      (click)="openDialogCreateDemand()"
      [disabled]="isLoading"
    >
      Preencher manualmente
    </button>

    @if (showTextField) {
      <button
        type="button"
        mat-flat-button
        color="accent"
        class="request-entry__primary-action"
        (click)="openDialogCreateDemand(true)"
        [disabled]="isLoading || !canUseAi"
        [matTooltip]="!canUseAi ? 'Descreva o problema com mais detalhes.' : ''"
        matTooltipPosition="above"
      >
        @if (isExtracting) {
          <mat-progress-spinner
            diameter="18"
            mode="indeterminate"
            color="accent"
            strokeWidth="3"
          ></mat-progress-spinner>
          <span>Consultando IA...</span>
        } @else {
          <span>Preencher via IA</span>
          <i-tabler name="sparkles" class="request-entry__action-icon"></i-tabler>
        }
      </button>
    } @else {
      <button
        type="button"
        mat-flat-button
        color="accent"
        class="request-entry__primary-action"
        (click)="transcribe()"
        [disabled]="isLoading || !audioUrl"
      >
        @if (isTranscribing) {
          <mat-progress-spinner
            diameter="18"
            mode="indeterminate"
            color="accent"
            strokeWidth="3"
          ></mat-progress-spinner>
          <span>Transcrevendo...</span>
        } @else {
          <span>Transcrever audio</span>
        }
      </button>
    }
  </mat-dialog-actions>
</section>
